module.exports = __webpack_public_path__ + "img/up_btn.8d7b5f49.png";